<template>
  <div class="plasmid">
    <h2 class="material-title">
      {{ materialTitle }}
    </h2>
    <slot />
  </div>
</template>

<script>
export default {
  name: "BioPlasmid",
  props: {
    materialTitle: {
      type: String,
      default: "Plasmid",
    },
  },
};
</script>

<style scoped>
.material-title {
  margin-bottom: 1rem;
}

.plasmid {
  background: #deebff;
  margin: 2rem;
  padding: 1rem;
}
</style>
